import {ID_BY_RANK, INTEGRATED_PRESIDENTIAL_DIRECTOR} from '/enum/rank.enum';

export const hasAchievedHighestRank = (currentRankId: any) => {
  return currentRankId === ID_BY_RANK[INTEGRATED_PRESIDENTIAL_DIRECTOR];
};
